{
  "en": {
    "tasks": {
      "panelTitle": "Tasks panel"
    },
    "archipadImport": {
      "title": "Archipad import",
      "processing": "File being processed",
      "success": "File processed successfully",
      "error": "Error while processing the file",
      "createObservations": "Create the observations",
      "pdfUploadFailed": "The pdf could not be added to the project documents",
      "invalidTemplate": "The Excel file does not match the Archipad template"
    },
    "archipadCreation": {
      "title": "Saving observations",
      "processing": "Observations being saved",
      "success": "Observations saved",
      "error": "Error while saving the observations",
      "count": "{count} observations"
    },
    "documentUpload": {
      "projectIdMissing": "Project ID not found, unable to upload"
    }
  },
  "fr": {
    "tasks": {
      "panelTitle": "Panneau des tâches"
    },
    "archipadImport": {
      "title": "Import Archipad",
      "processing": "Fichier en cours de traitement",
      "success": "Fichier traité avec succès",
      "error": "Erreur lors du traitement du fichier",
      "createObservations": "Créer les observations",
      "pdfUploadFailed": "Le pdf n'a pas pu être ajouté aux documents du projet",
      "invalidTemplate": "Le fichier excel ne correspond pas au modèle Archipad"
    },
    "archipadCreation": {
      "title": "Enregistrement des observations",
      "processing": "Observations en cours d'enregistrement",
      "success": "Observations enregistrées",
      "error": "Erreur lors de l'enregistrement des observations",
      "count": "{count} observations"
    },
    "documentUpload": {
      "projectIdMissing": "ID projet introuvable, impossible d'uploader"
    }
  },
  "nl": {
    "tasks": {
      "panelTitle": "Takenpaneel"
    },
    "archipadImport": {
      "title": "Archipad-import",
      "processing": "Bestand wordt verwerkt",
      "success": "Bestand succesvol verwerkt",
      "error": "Fout bij het verwerken van het bestand",
      "createObservations": "De adviezen aanmaken",
      "pdfUploadFailed": "De pdf kon niet aan de projectdocumenten worden toegevoegd",
      "invalidTemplate": "Het Excel-bestand komt niet overeen met het Archipad-sjabloon"
    },
    "archipadCreation": {
      "title": "Adviezen opslaan",
      "processing": "Adviezen worden opgeslagen",
      "success": "Adviezen opgeslagen",
      "error": "Fout bij het opslaan van de adviezen",
      "count": "{count} adviezen"
    },
    "documentUpload": {
      "projectIdMissing": "Project-ID niet gevonden, kan niet uploaden"
    }
  }
}
